import { defineLanguage } from "../registry";

export default defineLanguage({
  id: "javascript",
  extensions: [".js", ".mjs", ".cjs"],
  filenames: ["Jakefile"],
  runner: "javascript",
});
